import { ref } from "vue";

// Strictly below the 768px "tablet" token: at exactly 768 the desktop/tablet
// include-media styles (>=tablet) own the layout, so the shell must not.
export const MOBILE_BREAKPOINT_QUERY = "(max-width: 767.98px)";

let isMobileRef = null;

/**
 * Reactive "is the viewport phone-sized?" flag. Single matchMedia listener
 * shared app-wide so template branches and JS logic agree with the
 * `@media (max-width: 768px)` CSS breakpoint used across the codebase.
 */
export function useIsMobile() {
  if (!isMobileRef) {
    const mql =
      typeof matchMedia === "function"
        ? matchMedia(MOBILE_BREAKPOINT_QUERY)
        : null;
    isMobileRef = ref(mql ? mql.matches : false);
    mql?.addEventListener("change", (e) => (isMobileRef.value = e.matches));
  }
  return { isMobile: isMobileRef };
}
